import styled from 'styled-components'

export const ToggleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const Label = styled.label`
  font-size: 12px;
  font-weight: 500;
  color: #374151;
`

export const SwitchWrapper = styled.div`
  display: inline-flex;
  background-color: #e5e7eb;
  border-radius: 8px;
  padding: 4px;
  position: relative;
  width: 100%;
`

export const SwitchOption = styled.button<{ $isActive: boolean }>`
  flex: 1;
  padding: 8px 12px;
  font-size: 13px;
  font-weight: 500;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  background-color: ${({ $isActive }) =>
    $isActive ? '#ffffff' : 'transparent'};
  color: ${({ $isActive }) => ($isActive ? '#111827' : '#6b7280')};
  box-shadow: ${({ $isActive }) =>
    $isActive ? '0 1px 3px rgba(0, 0, 0, 0.1)' : 'none'};
  white-space: nowrap;

  &:hover {
    color: ${({ $isActive }) => ($isActive ? '#111827' : '#374151')};
  }

  &:focus {
    outline: none;
  }
`
